import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Eye, EyeOff, BookOpen, ArrowLeft } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1761492190275-129cf71ff124?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHx1bml2ZXJzaXR5JTIwc3R1ZGVudCUyMHN0dWR5aW5nJTIwbGlicmFyeSUyMG1vZGVybnxlbnwwfHx8fDE3NzgwNDU2NDZ8MA&ixlib=rb-4.1.0&q=85";

export default function LoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      if (user.role === "admin") navigate("/admin");
      else if (user.role === "dosen") navigate("/dosen");
      else navigate("/mahasiswa");
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.identifier || !form.password) { setError("NIM/NIP dan password wajib diisi"); return; }
    setLoading(true);
    try {
      await login(form.identifier, form.password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFDFD] font-[Manrope] flex items-center justify-center">
    {/* <div className="min-h-screen flex bg-[#FDFDFD] font-[Manrope]">
     Left Panel
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <img src={IMG} alt="University" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#002147]/80" />
        <div className="absolute inset-0 flex flex-col justify-end p-12">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 bg-white rounded-sm flex items-center justify-center">
              <BookOpen size={22} className="text-[#002147]" />
            </div>
            <span className="text-white font-bold text-xl font-[Outfit]">Monitoring TA</span>
          </div>
          <h2 className="text-white font-bold text-4xl font-[Outfit] leading-tight mb-3">
            Pantau Progress<br />Tugas Akhir Anda
          </h2>
          <p className="text-white/70 text-base leading-relaxed">
            Sistem monitoring bimbingan tugas akhir yang terintegrasi untuk mahasiswa, dosen, dan admin.
          </p>
          <div className="flex gap-6 mt-8">
            {[["8+", "Sesi Bimbingan"], ["2", "Dosen Pembimbing"], ["100%", "Transparan"]].map(([n, l]) => (
              <div key={l}>
                <p className="text-white font-bold text-2xl font-[Outfit]">{n}</p>
                <p className="text-white/60 text-xs">{l}</p>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Right Panel */}
      {/* <div className="flex-1 flex items-center justify-center px-6 py-12 relative"> */}
      <div className="w-full max-w-md px-6 py-20 relative">
        <Link
          to="/"
          data-testid="back-to-home"
          className="absolute top-4 left-6 flex items-center gap-2 bg-[#002147] hover:bg-[#001833] text-white px-4 py-2 rounded-sm shadow-sm text-sm font-semibold transition-all z-10"
        >
          <ArrowLeft size={16} />
          Kembali ke Beranda
        </Link>
        <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm p-8">
          <div className="mb-8">
            <div className="flex items-center gap-2 lg:hidden mb-6">
              {/* <div className="w-8 h-8 bg-[#002147] rounded-sm flex items-center justify-center">
                <BookOpen size={16} className="text-white" />
              </div>
              <span className="font-bold text-[#002147] font-[Outfit]">Monitoring TA</span> */}
            </div>
            <h1 className="text-3xl font-bold text-[#0F172A] font-[Outfit] mb-1">Selamat Datang</h1>
            <p className="text-[#475569] text-sm">Masuk ke akun Anda untuk melanjutkan</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">NIM / NIP</label>
              <input
                data-testid="login-email"
                type="text"
                value={form.identifier}
                onChange={e => setForm(p => ({ ...p, identifier: e.target.value }))}
                placeholder="Masukkan NIM atau NIP"
                className="w-full border border-slate-200 rounded-sm px-4 py-3 text-sm text-[#0F172A] focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">Password</label>
              <div className="relative">
                <input
                  data-testid="login-password"
                  type={showPass ? "text" : "password"}
                  value={form.password}
                  onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                  placeholder="••••••••"
                  className="w-full border border-slate-200 rounded-sm px-4 py-3 text-sm text-[#0F172A] focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all pr-10"
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#475569] hover:text-[#0F172A]"
                >
                  {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            {error && (
              <div data-testid="login-error" className="bg-red-50 border border-red-200 rounded-sm px-4 py-3 text-sm text-red-600">
                {error}
              </div>
            )}

            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#002147] hover:bg-[#001833] disabled:bg-slate-400 text-white py-3 rounded-sm font-semibold text-sm transition-all duration-200 active:translate-y-px"
            >
              {loading ? "Masuk..." : "Masuk"}
            </button>
          </form>

          <p className="text-center text-sm text-[#475569] mt-6">
            Belum punya akun?{" "}
            <Link to="/register" className="text-[#002147] font-semibold hover:underline" data-testid="register-link">
              Daftar sekarang
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
